import { ReactComponent as NewGoogleIcon } from "../../assets/images/google_logo.svg";

const GoogleIcon = ({ className, style }) => (
  <NewGoogleIcon className={className} style={style} />
);

export default GoogleIcon;
